import { createAction, props } from '@ngrx/store';
import {
  CloseDialogPayload,
  ConfirmDialogPayload,
  InitDialogPayload,
  UpdateDialogPayload,
} from './dialog.model';

export const DialogActions = {
  openDialog: createAction(
    '[Dialog] Open Dialog',
    props<{ payload: InitDialogPayload }>()
  ),
  updateDialog: createAction(
    '[Dialog] Update Dialog',
    props<{ payload: UpdateDialogPayload }>()
  ),
  closeDialog: createAction(
    '[Dialog] Close Dialog',
    props<{ payload: CloseDialogPayload }>()
  ),
  confirmDialog: createAction(
    '[Dialog] Close Dialog',
    props<{ payload: ConfirmDialogPayload }>()
  ),
};
